import { lowerFirst } from 'lodash-es';

export function createAlarmRecipientPlaceholder() {
    return `${gettext('E-mail address')} ${gettext('OR')} ${lowerFirst(gettext('Phone number'))}`;
}

export function createInvalidEmailOrPhoneText() {
    return `${gettext('INVALID')} ${lowerFirst(createAlarmRecipientPlaceholder())}.`;
}
